import React from "react";
import { DeleteOutline } from "@material-ui/icons";
import { Link } from "react-router-dom";
import { getImageURL } from "../../../utils/url";
import "./TaskCard.css";

const fixThumbnailUrl = (url) => {
  if (!url) {
    return process.env.PUBLIC_URL + "/backgrounds/revisionTask/nature.png";
  }

  if (url.startsWith("https://")) {
    return url;
  } else {
    return "https://xcell-cms-files.s3.amazonaws.com/" + url;
  }
};

export function TaskCard({ task, onDelete }) {
  return (
    <div className="task-card task-card-radius task-card-height">
      <DeleteOutline className="task-icon" onClick={() => onDelete(task)} />

      <Link to={`/tasklist/topic/${task._id}`}>
        <div className="">
          <div className="task-card-img">
            <img
              src={getImageURL(fixThumbnailUrl(task?.content?.thumbnail))}
              className="task-card-thumbnail"
              alt={task?.subject || "chapter"}
            />
          </div>

          <div className="text-center">
            <h5 className="text-dark" style={{ fontWeight: "bold" }}>
              {task?.subject}
            </h5>

            <p className="text-dark">{task?.content?.name || task?.name}</p>

            <span style={{ fontSize: "0.7rem" }}>
              {new Date(task.from).toDateString()}
            </span>
          </div>
        </div>
      </Link>
    </div>
  );
};

